<template>
  <div>
    <CollectionView searchable :endpoint="utilities.path('modules/support/players/@/tickets', playerId)" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("tickets") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("subject") }}</div>
                <div class="table-header-cell">{{ translate("category") }}</div>
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <a class="table-row" v-for="item in items" :key="item.id" @click="viewId = item.id">
                  <div class="table-column">
                    {{ item.subject }}
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-tag fa-lg me-2" :style="{ color: item.category.color }"></i> <span>{{ item.category.name }}</span>
                    </div>
                  </div>
                  <div class="table-column" :class="{ 'text-danger': item.status.id === 3, 'text-success': item.status.id === 2, 'text-info': item.status.id === 1 }">{{ item.status.title }}</div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <TargetedModalHttpFormView v-if="authorization.permission('modules.support.tickets.delete')" size="small" :endpoint="utilities.path('modules/support/tickets/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click.prevent.stop="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <h2 class="mb-4">{{ item.subject }}</h2>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView size="large" :active="viewId !== undefined" @update:active="viewId = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("ticket") }}</h3>
          <ModalCloseButtonView @click="viewId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <TicketView :community-id="communityId" :ticket-id="viewId" @updated="reload = true"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {
  CollectionView,
  utilities,
  ButtonView,
  SpinnerView,
  TargetedModalHttpFormView,
  ModalView,
  ModalCloseButtonView
} from "@/niftybit";
import {ref} from "vue";
import authorization from "@/authorization";
import TicketView from "@/systems/modules/support/TicketView.vue";

const props = defineProps({
  communityId: String,
  playerId: String
});

const reload = ref(false);

const viewId = utilities.routeQueryParam("viewId");

</script>